import { render } from "./BaseLoaderSpinner.vue?vue&type=template&id=57f87143&scoped=true"
import script from "./BaseLoaderSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoaderSpinner.vue?vue&type=script&lang=js"

import "./BaseLoaderSpinner.vue?vue&type=style&index=0&id=57f87143&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f87143"]])

export default __exports__